// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"f--z"};